import filter from 'lodash/filter';
import head from 'lodash/head';

export class TransportationProvidersService {
	constructor($resource, ApiService, DateService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.dateService = DateService;

		this.transportationProvidersResourceUrl = this.apiService.getResourceUrl('menus/TransportationProviders');
		// this.transportationProvidersFilterResourceUrl = this.apiService.getResourceUrl('menus/TransportationProviders/filter');
		this.transportationProvidersDetailsResourceUrl = this.apiService.getResourceUrl('transportation-providers/:content_id');

		this.transportationProvidersResource = this.$resource(this.transportationProvidersResourceUrl);
		// this.transportationProvidersFilterResource = this.$resource(this.transportationProvidersFilterResourceUrl);
		this.transportationProvidersDetailsResource = this.$resource(this.transportationProvidersDetailsResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getHoursOfOperationDetails(value) {
		return {
			startTime: value.start_time ? this.dateService.parseDateFromServerDate(value.start_time) : "",
			endTime: value.end_time ? this.dateService.parseDateFromServerDate(value.end_time) : "",
			isAllDay: value.is_all_day,
			byAppointment: value.by_appoinment
		}
	}

	_getCountyObject(values) {
		return values.map(value => ({
			id: value.service_area_id,
			name: `${value.name} (${value.state_code}) (${value.service_area_type})`
		}));
	}

	_getServiceNameObject(values) {
		return values.map(value => ({
			id: value.service_area_id,
			name: value.service_name
		}));
	}

	_getServicetypeObject(values) {
		return values.map(value => ({
			id: value.service_type_id,
			name: value.service_type
		}));
	}

	_getPaymentMethodObject(values) {
		return values.map(value => ({
			id: value.payment_method_id,
			name: value.payment_method
		}));
	}

	_getPhoneDetailsObject(values) {
		return values.map(({ extn = '', number = '', name = '' }) => ({ extn, number, name }));
	}

	_getContentData(data) {
		return data.map(value => ({
			id: value.content_id,
			countyName: this._getCountyObject(value.service_area),
			daysOfOperation: value.days_of_operation,
			email: value.email,
			hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
			image: value.image,
			name: value.name,
			fees: value.fees,
			notes: value.notes,
			methodOfPayment: this._getPaymentMethodObject(value.payment_methods),
			phone: this._getPhoneDetailsObject(value.phone_number),
			serviceName: value.service_area,
			serviceType: this._getServicetypeObject(value.service_type),
			url: value.url,
			slug: value.slug
		}));
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'TransportationProviders']);
		return this._getContentData(head(details).values);
	}

	_getCountyListObject(values) {
		let details = filter(values, ['name', 'serviceArea']);
		return _getCountyData(head(details).values);

		function _getCountyData(data) {
			return data.map(value => ({
				id: value.service_area_id,
				label: `${value.name} (${value.state_code}) (${value.service_area_type})`
			}));
		}
	}

	_getServiceTypeObject(values) {
		let details = filter(values, ['name', 'serviceType']);
		return _getServiceTypeData(head(details).values);

		function _getServiceTypeData(data) {
			return data.map(value => ({
				id: value.service_type_id,
				label: value.name
			}));
		}
	}

	_getServiceAreaObject(values) {
		let details = filter(values, ['name', 'serviceArea']);
		return _getServiceAreaData(head(details).values);

		function _getServiceAreaData(data) {
			return data.map(value => ({
				id: value.service_area_id,
				label: value.name
			}));
		}
	}

	/**
	 * function to get call for help content
	 * @return {object} [information related to call for help]
	 */

	getProviderDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			countyList: this._getCountyListObject(details.data.content),
			serviceTypeList: this._getServiceTypeObject(details.data.content),
			count: details.data.count,
			details: this._getContentObject(details.data.content)
		};
	}

	getProviderFilterData({
		id, serviceTypeId, filterDetails: { limit, pageId }
	}, url) {

		this.transportationProvidersFilterResourceUrl = this.apiService.getResourceUrl(`menus/${url}`);
		this.transportationProvidersFilterResource = this.$resource(this.transportationProvidersFilterResourceUrl);

		const promise = this.transportationProvidersFilterResource.get({
			service_area_id: id,
			service_type_id: serviceTypeId,
			limit,
			page_id: pageId
		}).$promise;

		return promise.then(details => this._getFilterDetailsObject(details))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getProviderDetailsById(details) {
		return this._getContentData([details.data]);
	}

	_getFilterDetailsObject(details) {
		let obj = {};
		obj.details = this._getContentObject(details.data.content);
		let providers = filter(details.data.content, ['name', 'TransportationProviders']);
		if (providers[0].hasOwnProperty('count')) {
			obj.count = providers[0].count;
		}

		return obj;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-providers/transportation-providers.service.js